import * as React from 'react'

export enum SiteCurrency {
  euro = '€',
  pound = '£',
  krona = 'kr.',
}

interface CurrencyPriceProps {
  currency: SiteCurrency
  price?: number
  short?: boolean
  noSpace?: boolean
}
const PriceWithCurrency: React.FC<CurrencyPriceProps> = ({
  currency,
  price,
  short,
  noSpace,
}) => {
  if (!price || price === 0) {
    return <>-</>
  }

  const displayedPrice = Math.round(price) === price ? price : price.toFixed(2)

  return short ? (
    <>{displayedPrice},-</>
  ) : (
    <>
      {currency === SiteCurrency.krona && `${displayedPrice}${currency}`}
      {[SiteCurrency.euro, SiteCurrency.pound].includes(currency) &&
        `${currency}${noSpace ? '' : ' '}${displayedPrice}`}
    </>
  )
}

export default PriceWithCurrency
